import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Typography } from '@mui/material'
import { AdminConfigsTabs } from './AdminConfigsTabs'
import { WeddingTasksConfigPanel } from './WeddingTasksConfigPanel'
import { PricingConfigPanel } from './PricingConfigPanel'
import styles from './AdminConfigsPage.module.scss'

const WEDDING_TASKS_PREFIX = '/admin/configs/wedding-tasks'

export function AdminConfigsPage() {
	const location = useLocation()
	const navigate = useNavigate()
	const [tabIndex, setTabIndex] = useState(() =>
		location.pathname.startsWith(WEDDING_TASKS_PREFIX) ? 0 : 1
	)

	useEffect(() => {
		if (location.pathname.startsWith(WEDDING_TASKS_PREFIX)) {
			setTabIndex(0)
		} else if (location.pathname === '/admin/configs') {
			setTabIndex(1)
		}
	}, [location.pathname])

	const handleTabChange = (_event, newValue) => {
		setTabIndex(newValue)
		if (newValue === 0) {
			navigate(WEDDING_TASKS_PREFIX)
		} else {
			navigate('/admin/configs')
		}
	}

	return (
		<div className={styles.root}>
			<div className={styles.pageHeader}>
				<Typography component="h1" className={styles.title}>
					Configs
				</Typography>
			</div>
			<div className={styles.pageMain}>
				<AdminConfigsTabs
					value={tabIndex}
					onChange={handleTabChange}
					weddingTasksPanel={<WeddingTasksConfigPanel />}
					pricingPanel={<PricingConfigPanel />}
				/>
			</div>
		</div>
	)
}
